<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
            v-if="userRole != 'punchlist'"
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title v-if="!drawer">{{ pageTitle }}</v-toolbar-title>
                <v-spacer v-if="!drawer"></v-spacer>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-if="!drawer"
                    >
                        <v-icon dark>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-else
                    large min-width="100%"
                    >
                        <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden accent" min-height="calc(100vh - 112px)" v-if="userRole != 'punchlist'">
            <v-card flat tile class="primary">  
                <v-list flat color="#004889" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Category</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="justify-end">
                            <div class="d-flex align-center">
                                <v-combobox
                                    v-model="mcat"
                                    :items="media_categories"
                                    item-text="title"
                                    item-value="id"
                                    label="Media Category"
                                    hide-details
                                    solo
                                    flat
                                    dark
                                ></v-combobox>
                                <v-btn
                                    class="ml-1"
                                    fab
                                    dark
                                    small
                                    text
                                    @click="categoryDialog = !categoryDialog"
                                >
                                    <v-icon dark>
                                        mdi-plus
                                    </v-icon>
                                </v-btn>
                            </div>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content>
                            <file-pond
                                name="filepond"
                                ref="filepond"
                                label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                v-bind:allow-multiple="true"
                                v-bind:allowImagePreview="false"
                                accepted-file-types="image/jpeg, image/png"
                                :server="{
                                    url: 'https://api.mrpoolal.com/api/crm/job/image?id='+id+'&category='+mcat.id,
                                    process: {
                                        headers: {
                                            'Authorization': `Bearer ${token}`
                                        }
                                    }
                                }"
                                v-bind:files="files"
                                v-on:init="handleFilePondInit"
                                v-on:processfile="handleFilePondProcessfile"
                                class="mb-0"
                                />
                        </v-list-item-content>
                    </v-list-item>
                </v-list>            
            </v-card>
            <template>
                <v-card flat tile class="pa-0" color="accent">
                    <v-card-text class="ma-0 pa-0">
                        <vue-picture-swipe :items="imgitems" :mcats="media_categories" @update-images="getImages"></vue-picture-swipe>
                    </v-card-text>
                </v-card>
            </template>
            <Drawer :show="drawer" :id="id" :cid.sync="customer" @update-drawer="updateDrawer" />
            <AddCategory :dialog="categoryDialog" type="media" @update-dialog="updateCategoryDialog" @update-categories="updateCategories"/>
        </v-card>
        <v-card
            class="mx-auto"
            flat
            tile
            v-if="userRole == 'punchlist'"
        >
            <v-card-text class="text-center">You don't have permission to view this page.</v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import Drawer from './Drawer.vue'
    import VuePictureSwipe from '../../components/Swipe/Swipe.vue'
    import AddCategory from '../../components/AddCategory.vue'
    import authmixin from '../../mixin/auth.js'

    export default {
        mixins: [authmixin],
        props: ['id'],
        data () {
            return {
                comments: [], 
                customer: '',
                loading: false,
                token: '',
                pageTitle: '',
                drawer: false,
                files: [],
                uploadedFiles: [],
                images: [],
                media_categories: [],
                mcat: {
                    id: '',
                    title: 'All',
                },
                categoryDialog: false,
            }
        },
        created() {
            this.getImages()
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        components: {
            Drawer,
            'vue-picture-swipe': VuePictureSwipe,
            AddCategory
        },
        computed: {
            filteredImages() {
                if(this.mcat.id) {
                    return this.images.filter(image => {
                        return image.category == this.mcat.id
                    })
                } else {
                    return this.images
                }
            },
            imgitems() {
                var arr = [];
            
                this.filteredImages.forEach(function(item) {
                    //var meta = JSON.parse(item.image_meta);
                    var img = {}; 
                    img ["src"] = 'https://api.mrpoolal.com/img/crmjobs/'+item.image+'?w=1000';
                    img ["thumbnail"] = 'https://api.mrpoolal.com/img/crmjobs/'+item.image+'?w=400&h=400&fit=crop';

                    let imgg = document.createElement('img');
                    imgg.id = 'imgId';
                    imgg.src = img ["src"];
                    document.body.appendChild(imgg);
                    let myImg = document.querySelector("#imgId");
                    img ["w"] = myImg.naturalWidth; // you modify it's properties
                    img ["h"] = myImg.naturalHeight; // you modify it's properties 
                    img ["id"] = item.id

                    arr.push(img); // you push it to the array
                });   

                return arr         
            }
        },
        methods: {
            getImages() {
                if(this.id) {
                    this.loading = true
                    axios.get('crm/job/images?id=' + this.id)
                        .then((response) => {
                            this.loading = false
                            this.images = response.data.images
                            this.media_categories = response.data.categories
                            this.customer = response.data.customer
                            this.$nextTick()
                        })
                }
            },
            updateDrawer(val) {
                this.drawer = val
            },
            updateCategoryDialog(val) {
                this.categoryDialog = val
            },
            updateCategories(val) {
                this.media_categories.push(val)  
                this.mcat = val
            },
            handleFilePondProcessfile: function (error, file) {
                if(this.images !== undefined)
                    this.images.push(JSON.parse(file.serverId))  
                    this.$nextTick()
            },
        }
    }
</script>

<style lang="sass">
.filepond--panel-center
    &.filepond--panel-root
        outline: none!important
</style>